import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import '../../Styles/app.scss';
import DetailsSection from './DetailsSection';
import HistorySection from './HistorySection';
import CallSection from './CallSection';
import useAPI from '../../api';
import useInfiniteQuery from '../../Hooks/useInfiniteQuery';
import { useAtomValue } from 'jotai';
import { selectedBranchAtom } from '../../Atoms';
import { CHANNEL_TYPES } from '../../Utils/constants/general';
import ActivityProgressSection from './ActivityProgressSection';
import { CenteredFlexBox, FlexBox } from '../../Components/FlexBox';
import ActionsDial from './Shared/ActionsDial';
import SectionBreadcrumbs from '../../Components/Breadcrumbs';

const CustomerSectionPage = function CustomerSectionPage({
  campaignId,
  activeCampaigns,
  handleOpenCampaignSelectionDialog,
  userRoles,
  selectedCustomer,
  contactIndex,
  handleChangeContactIndex,
  setSelectedPhoneNumber,
  setSelectedEmailAddress,
  changePhoneOrMail,
  isLead = false,
  customerId = null,
  activityParentId = null,
  selectedEmailAddress = null,
  selectedPhoneNumber = null,
  openReply = null,
  reloadCustomer = null,
  customerInformationData = null,
  actions = [],
  customerUnreadMessages = 0,
  sidebarOpen = false,
}) {
  const API = useAPI();
  const selectedBranch = useAtomValue(selectedBranchAtom);
  const [filterHistory, setFilterHistory] = useState('ALL');

  const callSelectedActivityFunction = (contactId, page, filter, signal) => {
    switch (filter) {
      case 'CALL':
        return API.getCallsHistory(contactId, {
          pageNumber: page,
          silent: true,
          signal,
        });
      case 'APPOINTMENT':
        return API.getAppointmentHistory(contactId, {
          pageNumber: page,
          silent: true,
          signal,
        });
      case 'EMAIL':
        return API.getEmailHistory(contactId, {
          pageNumber: page,
          silent: true,
          signal,
        });
      default:
        return API.getActivityHistory(contactId, {
          pageNumber: page,
          silent: true,
          signal,
        });
    }
  };

  const getActivitiesHistory = useCallback(
    (pageNumber, signal) => {
      if (customerId) {
        return callSelectedActivityFunction(
          customerId,
          pageNumber,
          filterHistory,
          signal
        );
      }
      return Promise.resolve([]);
    },
    [customerId, filterHistory]
  );

  const infiniteQueryData = useInfiniteQuery(getActivitiesHistory);

  return (
    <div
      className="route-wrapper"
      style={{ overflow: 'hidden', padding: '0px 16px 16px 16px' }}
    >
      <SectionBreadcrumbs />
      <div
        style={{
          width: 'inherit',
          height: 'calc(90% - 30px)',
          flexGrow: 1,
          display: 'inherit',
          gap: '1vw',
        }}
      >
        <DetailsSection
          campaignId={campaignId}
          activeCampaigns={activeCampaigns}
          handleOpenCampaignSelectionDialog={handleOpenCampaignSelectionDialog}
          customerId={customerId}
          contactIndex={contactIndex}
          selectedCustomer={selectedCustomer}
          selectedEmailAddress={selectedEmailAddress}
          handleChangeSelectedEmailAddress={setSelectedEmailAddress}
          customerInformationData={customerInformationData}
          changePhoneOrMail={changePhoneOrMail}
          isLead={isLead}
          reloadCustomer={reloadCustomer}
          isLongChannel={selectedBranch?.channelType === CHANNEL_TYPES.Long}
          handleChangeContactIndex={handleChangeContactIndex}
        />
        <CallSection
          campaignId={campaignId}
          contactIndex={contactIndex}
          reloadHistory={infiniteQueryData.reload}
          contactId={selectedCustomer?.contacts?.[contactIndex]?.id}
          userRoles={userRoles}
          isLead={isLead}
          activityParentId={activityParentId}
          selectedCustomer={selectedCustomer}
          selectedPhoneNumber={selectedPhoneNumber}
          handleChangeSelectedPhoneNumber={setSelectedPhoneNumber}
          changePhoneOrMail={changePhoneOrMail}
        />
        <HistorySection
          campaignId={campaignId}
          userRoles={userRoles}
          infiniteQueryData={infiniteQueryData}
          filterHistory={filterHistory}
          setFilterHistory={setFilterHistory}
          customerId={customerId}
          selectedCustomer={selectedCustomer}
          handleReply={openReply}
        />
      </div>

      {campaignId ? (
        <FlexBox
          height="10%"
          width="100%"
          gap="1vw"
          alignItems="center"
          paddingTop="1vh"
        >
          <ActivityProgressSection
            sidebarOpen={sidebarOpen}
            campaignId={campaignId}
            activeCampaigns={activeCampaigns}
            customerId={customerId}
          />
          <CenteredFlexBox
            sx={{
              position: 'relative',
              width: '70px',
              height: '100%',
            }}
          >
            {customerId && (
              <ActionsDial
                actions={actions}
                badgeNumber={customerUnreadMessages}
              />
            )}
          </CenteredFlexBox>
        </FlexBox>
      ) : (
        <>
          {customerId && (
            <ActionsDial
              actions={actions}
              badgeNumber={customerUnreadMessages}
            />
          )}
        </>
      )}
    </div>
  );
};

CustomerSectionPage.propTypes = {
  customerId: PropTypes.string,
  selectedCustomer: PropTypes.object.isRequired,
  activityParentId: PropTypes.string,
  selectedPhoneNumber: PropTypes.string,
  setSelectedPhoneNumber: PropTypes.func.isRequired,
  selectedEmailAddress: PropTypes.string,
  setSelectedEmailAddress: PropTypes.func.isRequired,
  openReply: PropTypes.func,
  openDialog: PropTypes.func,
  changePhoneOrMail: PropTypes.func,
  isLead: PropTypes.bool,
};
export default CustomerSectionPage;
